module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero is-primary section-service-list",
    attrs: {
      "id": "section-service-list"
    }
  }, [_c('div', {
    staticClass: "hero-body",
    staticStyle: {
      "color": "white"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-multiline is-gapless is-centered"
  }, [_c('div', {
    staticClass: "column is-10"
  }, [_c('h1', [_vm._v("$ > services")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "hero-body",
    staticStyle: {
      "padding": "0",
      "margin-bottom": "5em"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-multiline is-gapless is-centered"
  }, [_c('div', {
    staticClass: "column is-10"
  }, [_c('div', {
    staticClass: "columns is-multiline is-gapless"
  }, [_c('div', {
    staticClass: "column is-6 has-text-centered section-1",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('span', [_vm._v("bespoke solutions")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-6 has-text-centered section-2",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('span', [_vm._v("branding & collateral design")])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline is-gapless"
  }, [_c('div', {
    staticClass: "column is-6 has-text-centered section-3",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('span', [_vm._v("responsive to modern platforms")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-6 has-text-centered section-4",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('span', [_vm._v("mobile apps")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d8d73f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentServiceListSection.vue
// module id = 810
// module chunks = 1